import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
esp: (
	`
	<div class="poem">
		<p class="mb-3 text-center">
			<i>
				laŭ la temoj de iu novjara kunveno de Esperantaj poetoj ĉe Rajmond Schwarz
			</i>
		</p>
		<p class="poem-block mb-3">
			La glorigita Retoriko <br/>
			Efikas same kiel la pumiko: <br/>
			Ĝi helpas la terenon glati, plugi, <br/>
			Sed ne ebligas nin ĉielen flugi. <br/>
			Do, sen skrupuloj sidu ni al tablo <br/>
			Kaj se aperos antaŭ ni eĉ diablo <br/>
			Portante la novaĵon en letero <br/>
			Pri kiu jam pleniĝas la etero: <br/>
			Ke venas Nova jar’ kun bukloj sur peruko, <br/>
			Kaj la Malnova, hida, kun veruko, <br/>
			Forflugas… Kia bona estas trafo <br/>
			Kaj ni regalos la diablon per la kafo.
		</p>
		
		<p class="mb-3 text-center bold">* * *</p>

		<p class="poem-block mb-3">
			La printemp’ kun varma mano <br/>
			Zorgas pri l’ estonta pano. <br/>
			Malfermiĝas la tunelo <br/>
			El la land’, kie kamelo <br/>
			Pro jubila suna ĝuo <br/>
			Forgesinte pri la ŝuo <br/>
			Kuras laŭ ardanta sablo <br/>
			Tien, kie pretas tablo. <br/>
			Tie, por feliĉa fino <br/>
			Lin atendas akv’, ne vino! <br/>
			Komenciĝas idilio… <br/>
			Sed finiĝis iluzio: <br/>
			Estis sola superstiĉo <br/>
			Tiel kredi al feliĉo. <br/>
			Malfermiĝas la kurteno: <br/>
			Estis ne kamel’… l’azeno! 
		</p>
	</div>
	`
)
}

const itemName = {
esp: 'Rimludoj'
}

const item = {
itemlink: getLink(itemName.esp),
esp:{
	itemName: itemName.esp,
	itemContent: content.esp,
	itemAuthor: author.esp
}
}

export default item;